
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M38.19 49.75a20.2 20.2 0 112-19.75M48 1.72c-3.81 0-6.1 2.54-6.1 5.72 0 3.81 1.28 3.18 1.28 12.07s-5.72 9.54-5.72 21.61 5.45 16.52 5.45 16.52 1.28.64 5.09.64 5-.64 5-.64 5.46-4.45 5.46-16.52-5.72-12.71-5.72-21.61 1.27-8.26 1.27-12.07c.04-3.18-2.24-5.72-6.01-5.72zM52.41 15.48h-8.9M52.41 23.22h-8.9","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"21.05","cy":"29.75","r":"1.51","fill":"#241f21"}}),_c('circle',{attrs:{"cx":"25.09","cy":"35.81","r":"1.51","fill":"#241f21"}}),_c('circle',{attrs:{"cx":"29.13","cy":"29.75","r":"1.51","fill":"#241f21"}})])
          )
        }
      }
    